let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1sXQt")).then(() => parcelRequire('lDaLP'));